import { errorPlayerContainerNotCreated } from './errors';
export const playerThumbnailData = (container, parameters) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getAny();
    return player.thumbnailData(parameters.time);
};
